import * as Api from '@ViewModels';
import * as React from 'react';

export interface IConfigurableIntegrationSettingsContext<
	TIntegration extends Api.IConfigurableIntegration = Api.IConfigurableIntegration,
> {
	accountId: string;
	integration?: TIntegration;
	integrationName: string;
	integrationType: Api.ConfigurableIntegrationType;
	onOwnerShipRoleChanged?(ownershipRole: string): void;
	ownershipRole?: string;
}

export const ConfigurableIntegrationSettingsContext =
	React.createContext<IConfigurableIntegrationSettingsContext>(null);

export const useConfigurableIntegrationSettingsContext = () => {
	const context = React.useContext(ConfigurableIntegrationSettingsContext);
	if (!context) {
		throw new Error(`This component requires the use of "ConfigurableIntegrationSettingsContext"`);
	}
	return context;
};
